import { Checkbox, FormControlLabel } from "@mui/material";
import {
  ArrowLeft,
  Edit,
  PlusCircle,
  Trash,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../../API/newIndex";
import { DataLoad, PlanPermission } from "../../App";
import Breadcrumbs from "../../controllers/breadCrumbs";
import MuiSwitch from "../../controllers/MuiSwitch";
import {
  ButtonComponent,
  CommonTable,
  ConfirmationPopup
} from "@shopeasy-dashboard-ui/ui-library";
import NoRecords from "../Main/NoRecords";
import Notification from "../Notification";

const GetBlogGroup = () => {
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  const { setPlanPermission } = useContext(PlanPermission);
  const navigate = useNavigate();
  const [groupBlogData, setGroupBlogData] = useState();
  const { dataLoading, setDataLoading } = useContext(DataLoad);
  const [selectedRowsId, setSelectedRowsId] = useState([]);
  const getBlogData = async () => {
    setDataLoading(true);
    try {
      const data = await API({ url: `/admin/dynamicBlog/getBlogGroups`, method: "get" });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setGroupBlogData(result?.data);
      }
    } catch (error) {
      if (error?.response?.status === 882) {
        setPlanPermission({ isPlanPermissions: false, forModule: "Blog" });
      }
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setDataLoading(false);
    }
  };
  useEffect(() => {
    getBlogData();
  }, []);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const handleDelete = async () => {
    try {
      const payload = {
        id: selectedRowsId,
      };
      const data = await API({
        url: `/admin/dynamicBlog/deleteBlogGroup`,
        method: "post",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        setIsNotification(true);
        setNotificationMsg("Removed SuccesFully!");
        setSeverity("success");
        getBlogData();
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setConfirmationPopup(false);
  };
  const handleCloseConfirm = (value) => {
    setConfirmationPopup(value);
  };
  const UpdateBlogStatus = async (row, value) => {
    try {
      const payload = {
        status: value,
      };
      const data = await API({
        url: `/admin/dynamicBlog/updateBlogGroup/${row._id}`,
        method: "put",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        getBlogData();
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };
  const handleSelectRow = (e, id) => {
    if (e?.nativeEvent?.shiftKey) {
      const prevIndex = groupBlogData?.findIndex(
        (x) => x._id === selectedRowsId[selectedRowsId?.length - 1],
      );
      const currIndex = groupBlogData?.findIndex((x) => x._id === id);
      const startIndex = Math.min(prevIndex, currIndex);
      const endIndex = Math.max(prevIndex, currIndex);
      const shiftSelected = groupBlogData?.slice(startIndex, endIndex + 1);

      if (selectedRowsId?.includes(id)) {
        setSelectedRowsId((prev) => [
          ...new Set(prev.filter((x) => !shiftSelected.find((item) => item._id === x))),
        ]);
      } else {
        setSelectedRowsId((prev) => [
          ...new Set([...prev, ...shiftSelected.map((item) => item._id)]),
        ]);
      }
    } else if (id === "all") {
      if (selectedRowsId?.length > 0) {
        setSelectedRowsId([]);
      } else {
        setSelectedRowsId(groupBlogData?.map((x) => x?._id));
      }
    } else {
      const existId = selectedRowsId?.includes(id);
      if (!existId) {
        setSelectedRowsId((prev) => [...prev, id]);
      } else {
        setSelectedRowsId((prev) => prev.filter((x) => x !== id));
      }
    }
  };
  const columns = [
    {
      key: "checkbox",
      title: (
        <Checkbox
          checked={
            groupBlogData?.length > 0 &&
            selectedRowsId?.length === groupBlogData?.length
          }
          indeterminate={
            selectedRowsId?.length > 0 &&
            selectedRowsId?.length < groupBlogData?.length
          }
          onChange={(e) => handleSelectRow(e, "all")}
        />
      ),
      align: "text-left",
      ignoreRowClick: true,
      width: "40px",
      minWidth: "40px",
      maxWidth: "40px",
      headerClassName: "!px-0 w-[40px] min-w-[40px] max-w-[40px] flex items-center justify-center",
      cellClassName: "!px-0 w-[40px] min-w-[40px] max-w-[40px] flex items-center justify-center",
      render: (row) => (
        <Checkbox
          checked={selectedRowsId?.length > 0 && selectedRowsId?.includes(row._id)}
          onChange={(e) => handleSelectRow(e, row._id)}
        />
      ),
    },
    {
      key: "group_name",
      title: t("lang_group_name"),
      headerClassName: "w-full px-3 uppercase",
      cellClassName: "w-full px-3",
      render: (row) => (
        <span className="line-clamp-2 text-xs font-medium text-[var(--primary-text-color)]">
          {row.blog_section_title ? row.blog_section_title.replace(/<[^>]*>/g, " ") : "-"}
        </span>
      ),
    },
    {
      key: "status",
      title: t("lang_status"),
      headerClassName: "min-w-[120px] max-w-[120px] px-3 text-right uppercase",
      cellClassName: "min-w-[120px] max-w-[120px] px-3 text-right",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <label className="relative flex justify-end w-full">
          <FormControlLabel
            checked={row?.status}
            control={<MuiSwitch />}
            onChange={() => UpdateBlogStatus(row, !row?.status)}
          />
        </label>
      ),
    },
    {
      key: "action",
      title: t("lang_action"),
      headerClassName: "min-w-[80px] max-w-[80px] w-[80px] px-3 text-right uppercase",
      cellClassName: "min-w-[80px] max-w-[80px] w-[80px] px-3 text-right",
      align: "text-right",
      ignoreRowClick: true,
      render: (row) => (
        <div className="flex items-center space-x-2.5 w-full justify-end">
          <button onClick={() => navigate(`/module-setting/blog-group/${row?._id}`)}>
            <Edit className="w-[16px] h-[16px] text-[var(--table-text-color)] hover:text-[var(--primary-text-color)] transition-colors" />
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              setConfirmationPopup(true);
              setSelectedRowsId([row?._id]);
            }}
          >
            <Trash className="w-[16px] h-[16px] text-red-500 hover:text-red-600 transition-colors" />
          </button>
        </div>
      ),
    },
  ];

  const tableHeader = selectedRowsId?.length > 0 ? (
    <div className="relative w-full border-b main-border-color secondary-bg-color px-3 py-2 flex items-center gap-1 min-h-[40px]">
      <span className="text-sm px-2 whitespace-nowrap">
        {selectedRowsId?.length} {t("lang_selected")}
      </span>
      <span className="me-1">|</span>
      <button
        className="bulk-btn mx-1 inline-flex items-center space-x-2 whitespace-nowrap"
        onClick={(e) => {
          e.preventDefault();
          setConfirmationPopup(true);
        }}
      >
        <Trash2 className="w-3.5 h-3.5" />
        <span>{t("lang_delete_selection")}</span>
      </button>
    </div>
  ) : null;

  return (
    <>
      <ConfirmationPopup
        heading="Delete Blog Group"
        subheading="Do you really want to delete this blog group?"
        confirmationPopup={confirmationPopup}
        handleCloseConfirm={handleCloseConfirm}
        runFunction={handleDelete}
      />
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto pb-[64px]">
        <div className="flex flex-wrap items-end justify-between w-full pb-[16px] sm:pb-[30px]">
          <div className="flex items-center space-x-2">
            <button
              onClick={(e) => {
                e.preventDefault();
                navigate("/dashboard");
              }}
              className="back-arrow -ml-3.5"
            >
              <ArrowLeft />
            </button>
            <div>
              <Breadcrumbs
                crumbs={[
                  { name: t("lang_dashboard"), path: `/dashboard` },
                  { name: t("lang_Blog_Group"), path: "/module-setting/blog-group" },
                ]}
              />
              <h4 className="text-xl md:text-2xl font-semibold text-primary">
                {t("lang_Blog_Group")}
              </h4>
            </div>
          </div>
          <div>
            <ButtonComponent
              variant="primary"
              icon={<PlusCircle className="w-4 h-4" />}
              onClick={() => navigate("/module-setting/blog-group/add-blog-group")}
            >
              {t("lang_Add_New_Blog_Group")}
            </ButtonComponent>
          </div>
        </div>

        <div className="w-full space-y-3">
          <CommonTable
            columns={columns}
            data={groupBlogData}
            tableHeader={tableHeader}
            loading={dataLoading}
            emptyMessage={<NoRecords />}
            rowClick={(row) => navigate(`/module-setting/blog-group/${row?._id}`)}
            rowClassName={(row) =>
              `select-none ${selectedRowsId?.find((x) => x === row?._id) ? "selected-row" : ""}`
            }
          />

          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate("/module-setting");
            }}
            className="w-fit flex text-link font-medium hover:underline text-sm items-center pt-2"
          >
            <ArrowLeft className="w-3 mr-1" />
            {t("lang_Go_To_Module_Setting")}
          </Link>
        </div>
      </div>
    </>
  );
};

export default GetBlogGroup;
